import PageMetaHead from 'src/logic/config/meta/PageMetaHead';
import CategoriesSlider from 'src/ui/components/smart/landing/home/CategoriesSlider';
import CategoriesSliderAsCards from 'src/ui/components/smart/landing/home/CategoriesSliderAsCards';
import Faq from 'src/ui/components/smart/landing/home/Faq';
import HomeBlogPosts from 'src/ui/components/smart/landing/home/HomeBlogPosts';
import HomeHero from 'src/ui/components/smart/landing/home/HomeHero';
import HowItWorks from 'src/ui/components/smart/landing/home/HowItWorks';
import IntelligentProcurement from 'src/ui/components/smart/landing/home/IntelligentProcurement';
import PricingOptions from 'src/ui/components/smart/landing/home/PricingOptions';
import ProcurementOverview from 'src/ui/components/smart/landing/home/ProcurementOverview';
import Statistics from 'src/ui/components/smart/landing/home/Statistics';
import LandingLayout from 'src/ui/components/smart/landing/layout/LandingLayout';

const Home = () => {
  return (
    <>
      <PageMetaHead
        page_meta={{
          title: 'AI-Powered Procurement Solutions for Modern Businesses',
          description:
            'Streamline your procurement process with AI-driven solutions, Automate tendering, sourcing, contract approvals, and supplier management using smart SaaS software.',
        }}
      />
      <div className='page'>
        <HomeHero />
        <CategoriesSlider />
        <span className='anchor' id='how-it-works'></span>
        <HowItWorks />
        <Statistics />
        <PricingOptions />
        <IntelligentProcurement />
        <ProcurementOverview />
        <CategoriesSliderAsCards />
        <HomeBlogPosts />
        <Faq />
      </div>
    </>
  );
};

Home.getLayout = function getLayout(page: React.ReactElement) {
  return <LandingLayout>{page}</LandingLayout>;
};

export default Home;
